export enum ComplianceRequirement {
  SIGN_IN = 'signIn',
  TERMS_OF_USE = 'termsOfUse',
  NONE = 'none'
}